export default __webpack_public_path__ + "static/media/kitchen4-afterC-1440w.b668e015.avif";